import { render, staticRenderFns } from "./ListFormModal.vue?vue&type=template&id=8182ca1e"
import script from "./ListFormModal.vue?vue&type=script&lang=js"
export * from "./ListFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports